import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import PageContainer from 'components/PageContainer/PageContainer';
import UploadShipments from 'components/UploadShipments/UploadShipments';
import useFileTypeUploadWarning from 'hooks/useFileTypeUploadWarning';

function UploadOllasPage() {
  const group = useFileTypeUploadWarning('ollas');

  return (
    <PageContainer title="Subida de archivos de Ollas GM">
      <UploadShipments group={group} />
    </PageContainer>
  );
}

export default withDashboardLayout(UploadOllasPage);
